import * as React from 'react';
import { IconProps } from '../types';

const IcMenuQRScan = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g fill={props?.fill ?? '#232F3E'} clipPath="url(#a)">
      <path d="M3.75 3.25V7H2.5V3.625c0-.375.125-.875.5-1.125.25-.375.75-.5 1.125-.5H7.5v1.25H3.75Z" />
      <path
        fillRule="evenodd"
        d="M3.436 2.75H7V2.5H4.125c-.295 0-.566.098-.689.25Zm-.186.186c-.152.123-.25.394-.25.689V6.5h.25V2.936Zm-.608-.794C3.04 1.627 3.708 1.5 4.125 1.5H8v2.25H4.25V7.5H2V3.625c0-.417.127-1.085.642-1.483Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M2.75 2.748A.947.947 0 0 1 3 2.5a.947.947 0 0 1 .248-.25c.261-.183.602-.25.877-.25H7.5v1.25H3.75V7H2.5V3.625c0-.275.067-.616.25-.877Zm2 1.502H8.5V1H4.125c-.465 0-1.3.133-1.839.786-.653.54-.786 1.374-.786 1.839V8h3.25V4.25Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M1.931 1.431C2.611.641 3.61.5 4.125.5H9v4.25H5.25V8.5H1V3.625c0-.516.14-1.515.931-2.194Zm1.362.229a1.561 1.561 0 0 0-.621.444l-.03.037-.038.03a1.561 1.561 0 0 0 .037-.03c.094-.12.204-.22.32-.3.106-.075.218-.134.332-.181Zm.832.84c-.21 0-.44.054-.59.16a.47.47 0 0 0-.099.09H7V2.5H4.125Zm-.875.436V6.5H3V3.625c0-.21.054-.44.16-.59a.47.47 0 0 1 .09-.099Z"
        clipRule="evenodd"
      />
      <path d="M20.875 2c.5 0 .875.125 1.125.5.375.25.5.75.5 1.125V7h-1.25V3.25H17.5V2h3.375Z" />
      <path
        fillRule="evenodd"
        d="M17 1.5h3.875c.56 0 1.106.139 1.485.643.514.4.64 1.066.64 1.482V7.5h-2.25V3.75H17V1.5Zm1 1v.25h3.565c-.12-.163-.299-.25-.69-.25H18Zm3.75.436V6.5H22V3.625c0-.295-.098-.566-.25-.689Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M21.772 2.25c.085.067.161.15.228.25.1.067.183.152.25.248.183.261.25.602.25.877V7h-1.25V3.25H17.5V2h3.375c.366 0 .665.067.897.25Zm-1.522 2H16.5V1h4.375c.627 0 1.338.157 1.844.79.649.54.781 1.372.781 1.835V8h-3.25V4.25Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M16 .5h4.875c.692 0 1.566.171 2.203.94.782.678.922 1.67.922 2.185V8.5h-4.25V4.75H16V.5Zm2 2v.25h3.565a.548.548 0 0 0-.103-.107c-.106-.085-.275-.143-.587-.143H18Zm3.75.436V6.5H22V3.625c0-.21-.054-.44-.16-.59a.47.47 0 0 0-.09-.099Z"
        clipRule="evenodd"
      />
      <path d="M3.75 17v3.75H7.5V22H4.125c-.5 0-.875-.125-1.125-.5-.375-.25-.5-.75-.5-1.125V17h1.25Z" />
      <path
        fillRule="evenodd"
        d="M2 16.5h2.25v3.75H8v2.25H4.125c-.56 0-1.106-.139-1.485-.643-.514-.4-.64-1.066-.64-1.482V16.5Zm1 1v2.875c0 .295.098.566.25.689V17.5H3Zm.435 3.75c.12.163.299.25.69.25H7v-.25H3.435Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M4.75 16v3.75H8.5V23H4.125c-.627 0-1.338-.157-1.844-.79-.649-.54-.781-1.372-.781-1.835V16h3.25Zm-1.522 5.75c.232.183.531.25.897.25H7.5v-1.25H3.75V17H2.5v3.375c0 .274.067.616.25.877.067.096.15.181.25.248.067.1.143.183.228.25Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M1 15.5h4.25v3.75H9v4.25H4.125c-.692 0-1.566-.171-2.203-.94C1.14 21.883 1 20.89 1 20.376V15.5Zm2 2v2.875c0 .21.054.44.16.59.028.04.058.073.09.099V17.5H3Zm.435 3.75a.55.55 0 0 0 .103.107c.106.085.275.143.587.143H7v-.25H3.435Zm-1.275-.043c.092.226.233.445.44.618l.04.033.032.04c.372.466.902.602 1.453.602-.42 0-.85-.076-1.207-.357a1.541 1.541 0 0 1-.278-.287 1.465 1.465 0 0 1-.3-.317 1.729 1.729 0 0 1-.18-.332Z"
        clipRule="evenodd"
      />
      <path d="M21.25 20.75V17h1.25v3.375c0 .5-.125.875-.5 1.125-.25.375-.75.5-1.125.5H17.5v-1.25h3.75Z" />
      <path
        fillRule="evenodd"
        d="M20.75 16.5H23v3.875c0 .56-.139 1.106-.643 1.485-.4.514-1.066.64-1.482.64H17v-2.25h3.75V16.5Zm1 1v3.565c.163-.12.25-.299.25-.69V17.5h-.25Zm-.186 3.75H18v.25h2.875c.295 0 .566-.098.689-.25Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M22.25 21.272a1.07 1.07 0 0 1-.25.228.947.947 0 0 1-.248.25c-.261.183-.602.25-.877.25H17.5v-1.25h3.75V17h1.25v3.375c0 .366-.067.665-.25.897Zm-2-1.522V16h3.25v4.375c0 .627-.157 1.338-.79 1.844-.54.649-1.372.781-1.835.781H16.5v-3.25h3.75Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M19.75 15.5H24v4.875c0 .692-.171 1.566-.94 2.203-.678.782-1.67.922-2.185.922H16v-4.25h3.75V15.5Zm2 2v3.565a.547.547 0 0 0 .107-.103c.085-.106.143-.275.143-.587V17.5h-.25Zm-.186 3.75H18v.25h2.875c.21 0 .44-.054.59-.16a.467.467 0 0 0 .099-.09ZM20.852 12.753H4.148v-2.196h16.704v2.196Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M3.648 10.057h17.704v3.196H3.648v-3.196Zm1 1v1.196h15.704v-1.196H4.648Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M2.5 2h20v20h-20z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcMenuQRScan;
